import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { PlayerInfoActionsMenuButton } from './playerInfoActionsMenuButton';
import { PlayerInfoMessagesButton } from './playerInfoMessagesButton';
const CONTAINER_CSS = css `
  display: flex;
  flex-direction: row;
  gap: 1px;
`;
export const PlayerInfoPanelButtonGroup = ({ playerInfo, isFriend }) => {
    return (_jsxs("div", { css: CONTAINER_CSS, children: [_jsx(PlayerInfoMessagesButton, { playerIdName: playerInfo.playerIdName }), _jsx(PlayerInfoActionsMenuButton, { playerInfo: playerInfo, isFriend: isFriend })] }));
};
